var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        { staticClass: "align-items-center justify-content-center" },
        [
          _c(
            "b-col",
            { staticClass: "px-md-5 form-page", attrs: { cols: "12" } },
            [
              _c("page-header", {
                attrs: {
                  title: _vm.$t("support.title"),
                  subtitle: _vm.$t("support.subtitle"),
                  "container-class": "mb-4",
                  size: "col-12",
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right-inner-addon" },
                [
                  _c("icon", { attrs: { name: "search" } }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.search,
                        expression: "search",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "form-control search-clients",
                    attrs: {
                      id: "search",
                      type: "search",
                      placeholder: _vm.$t(
                        "support.messages.whatCanWeHelpYouWith"
                      ),
                      autocomplete: "off",
                    },
                    domProps: { value: _vm.search },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search = $event.target.value.trim()
                      },
                      blur: function ($event) {
                        return _vm.$forceUpdate()
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    { staticClass: "d-none", attrs: { for: "search" } },
                    [_vm._v(_vm._s(_vm.$t("global.words.search")))]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c(
                "b-card",
                { attrs: { "body-class": "p-0" } },
                [
                  _vm.loading
                    ? _c("support-loader")
                    : [
                        _c("navbar", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.filterBySearch,
                              expression: "!filterBySearch",
                            },
                          ],
                          attrs: {
                            "current-tab": _vm.currentTab,
                            tabs: _vm.tabs,
                            "container-class": "scroll-container",
                          },
                          on: { "tab-change": _vm.handleTabChange },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "container-accordion" }, [
                          _c(
                            "div",
                            { staticClass: "tab-content" },
                            [
                              _vm.filteredFAQ.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "tab-pane fade show active px-0 px-sm-5 pt-0",
                                    },
                                    _vm._l(
                                      _vm.filteredFAQ,
                                      function (ref, index) {
                                        var question = ref.question
                                        var answer = ref.answer
                                        return _c("support-item", {
                                          key:
                                            "question-" +
                                            _vm.currentTab +
                                            "-" +
                                            index,
                                          attrs: {
                                            id:
                                              "question-" +
                                              _vm.currentTab +
                                              "-" +
                                              index,
                                            question: question,
                                            answer: answer,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _c(
                                    "no-results",
                                    {
                                      attrs: {
                                        "img-src": require("@Shared/@Assets/img/application-missing.png"),
                                        "img-class": "my-2",
                                        "text-class": "regular text-light-gray",
                                        "text-style": "",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("support.messages.emptyFAQ")
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  ),
                            ],
                            1
                          ),
                        ]),
                      ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }